import { render, staticRenderFns } from "./InfoBoxAddress.vue?vue&type=template&id=54c45522&"
import script from "./InfoBoxAddress.vue?vue&type=script&lang=js&"
export * from "./InfoBoxAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports